import React from 'react'

import { Routes , Route} from 'react-router-dom';
import Quote from './component/Quote'
import Hero from './component/Hero';
import Roadmap from './Roadmap';
import Footer from './component/Footer';
import HandNotes from './HandNotes';
import Story from './Story'
import Resume from './Resume'
import InterviewPrep from './component/InterviewPrep/InterviewPrep';
import Qantum from './Qantum';
import Papers from './Papers';
import Ai from './Ai';
import Frequent from './Frequent';
import Faq from './Faq/Faq';
import Information from './Information/Information'
import Contact from './Contact/Contact';



const Home = () => {
  return (
    <>
        
       
        <Hero/>

        <Information/>
        <Quote/>
        <Roadmap/>
        <Story/>
        <HandNotes/>       
        <InterviewPrep/> 
        <Qantum/>
        <Frequent/>
        <Contact/>        
        <Ai/>

        <Faq/>

        


    </>
  )
}

export default Home